import { withTransaction } from '@y42/gojs';
import * as go from 'gojs';
import {
  OrchestrationDerivedNode,
  OrchestrationDerivedNodeDictionary,
  OrchestrationDiagramModelProperties,
  OrchestrationUINode,
} from '../../models/orchestration-diagram.model';

export const addNodesAndLinksToDiagram = (diagram: go.Diagram, nodes: go.ObjectData[], links: go.ObjectData[]) => {
  withTransaction(
    diagram,
    () => {
      diagram.model.addNodeDataCollection(nodes);
      (diagram.model as go.GraphLinksModel).addLinkDataCollection(links);
      diagram.layoutDiagram(true);
    },
    'addNodesAndLinks',
  );
};

export const addLinksToDiagram = (diagram: go.Diagram, links: go.ObjectData[]) => {
  withTransaction(diagram, () => (diagram.model as go.GraphLinksModel).addLinkDataCollection(links), 'addLinks');
};
export const addNodesToDiagram = (diagram: go.Diagram, nodes: go.ObjectData[]) => {
  withTransaction(diagram, () => diagram.model.addNodeDataCollection(nodes), 'addNodes');
};

export const getOrchestrationDiagramModelProperty = <T>(
  property: OrchestrationDiagramModelProperties,
  diagram?: go.Diagram | null,
  defaultValue: Record<string, unknown> | T = {},
): T => diagram?.model.modelData[property] || defaultValue;

export const getOrchestrationDerivedNode = (
  node: OrchestrationUINode,
  diagram: go.Diagram,
): OrchestrationDerivedNode | null => {
  const derivedNodeDictionary = getOrchestrationDiagramModelProperty<OrchestrationDerivedNodeDictionary>(
    OrchestrationDiagramModelProperties.DerivedNodesDictionary,
    diagram,
  );
  return derivedNodeDictionary[node.path] || null;
};
